import React from 'react';
import { StyledHeading1 } from './PageHeaderV2.styled';

type HeaderProps = {
  title: string;
  testId?: string;
};

export const PageHeaderV2 = (props: HeaderProps) => {
  const { title, testId } = props;
  return (
    <>
      <StyledHeading1 data-testid={testId}>{title}</StyledHeading1>
    </>
  );
};
